import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import pulsarIcon from '../assets/brand/pulsar-icon-full.png';
import '../styles/Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setMobileMenuOpen(false);
    // Navigate to home first if not already there
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <div className="navbar__logo">
          <Link to="/" onClick={handleLinkClick}>
            <img src={pulsarIcon} alt="Pulsar" className="navbar__logo-img" />
            <span className="navbar__logo-text">Pulsar</span>
          </Link>
        </div>

        <button
          className="navbar__hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className={`navbar__hamburger-line ${mobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`}></span>
          <span className={`navbar__hamburger-line ${mobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`}></span>
          <span className={`navbar__hamburger-line ${mobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`}></span>
        </button>

        <ul className={`navbar__menu ${mobileMenuOpen ? 'navbar__menu--open' : ''}`}>
          <li className="navbar__menu-item">
            <a href="#hero" className={isActive('/') ? 'is-active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>
              Home
            </a>
          </li>
          <li className="navbar__menu-item">
            <Link to="/gridx" className={isActive('/gridx') ? 'is-active' : ''} onClick={handleLinkClick}>GRIDx</Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/team" className={isActive('/team') ? 'is-active' : ''} onClick={handleLinkClick}>Team</Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/mission" className={isActive('/mission') ? 'is-active' : ''} onClick={handleLinkClick}>Mission</Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/careers" className={isActive('/careers') ? 'is-active' : ''} onClick={handleLinkClick}>Careers</Link>
          </li>
          <li className="navbar__menu-item navbar__menu-item--cta">
            <Link to="/contact" className="btn btn--primary navbar__cta" onClick={handleLinkClick}>Contact Us</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
